import { createTheme } from "@mui/material";

const theme = createTheme({
    components: {
      MuiTableCell:{
        styleOverrides:{
            body:{
                color: "rgb(100, 100, 100)"
            }
        }
      }
    },
  });

export default theme;